import { useEffect, useRef } from 'react';

const useWheelHack = () => {
  const elementRef = useRef();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const $element = elementRef.current;
    if ($element) {
      const maybeCancelWheel = evt => {
        evt.preventDefault();
      };
      $element.addEventListener('wheel', maybeCancelWheel, { passive: false });
      return () => {
        $element.removeEventListener('wheel', maybeCancelWheel);
      };
    }
  }, []);

  return elementRef;
};

export default useWheelHack;
